import { useEffect, useState } from 'react';
import { Box, Button, Snackbar, useTheme } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import { tokens } from '../../theme';

const AssignedTrips = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const token = localStorage.getItem('token');
  const adminUserJson = localStorage.getItem('adminUser');
  const adminUser = adminUserJson ? JSON.parse(adminUserJson) : null;
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const getData = async () => {
    setLoading(true);
    try {
      const query = new URLSearchParams();
      query.set('page', String(page));
      query.set('limit', String(pageSize));
      if (Number(adminUser?.role) === 1 || Number(adminUser?.role) === 2) {
        query.set('coordinatorId', String(adminUser?.a_id || ''));
      }
      const res = await fetch(
        `${process.env.REACT_APP_APILINK}/api/admin/assigned-trips?${query.toString()}`,
        { headers: { token } }
      );
      const data = await res.json();
      if (data.success) {
        setRows(data.data || []);
        setTotalCount(data.pagination?.total || 0);
      } else {
        setToastMessage(data.message || 'Failed to load assigned trips');
        setOpenToast(true);
      }
    } catch (e) {
      setToastMessage('Failed to load assigned trips');
      setOpenToast(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize]);

  const columns = [
    { field: 'destination', headerName: 'Destination', flex: 1, minWidth: 160 },
    { field: 'departureDate', headerName: 'Departure Date', flex: 1, minWidth: 130 },
    { field: 'busCount', headerName: 'Bus Count', flex: 0.6, minWidth: 100 },
    { field: 'guideNames', headerName: 'Guide Name(s)', flex: 1.2, minWidth: 220 },
    {
      field: 'view',
      headerName: 'View',
      filterable: false,
      sortable: false,
      minWidth: 100,
      renderCell: (params) => (
        <Link to={`/assigned-trips/${params.row.countryId}/${params.row.departureDate}`}>
          <Button
            sx={{
              backgroundColor: colors.blueAccent[600],
              color: colors.grey[100],
              ':hover': { backgroundColor: colors.blueAccent[700] },
            }}
            variant="contained"
          >
            <VisibilityIcon />
          </Button>
        </Link>
      ),
    },
  ];

  return (
    <Box m="20px">
      <Header title="ASSIGNED TRIPS" subtitle="Trips assigned to coordinator" />
      <Box
        m="10px 0 0 0"
        height="667px"
        sx={{
          '& .MuiDataGrid-root': { border: 'none' },
          '& .MuiDataGrid-cell': { borderBottom: 'none' },
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: colors.blueAccent[700],
            borderBottom: 'none',
          },
          '& .MuiDataGrid-virtualScroller': { backgroundColor: colors.primary[400] },
          '& .MuiDataGrid-footerContainer': {
            borderTop: 'none',
            backgroundColor: colors.blueAccent[700],
          },
          '& .MuiDataGrid-toolbarContainer .MuiButton-text': {
            color: `${colors.grey[100]} !important`,
            fontSize: 14,
          },
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          loading={loading}
          disableRowSelectionOnClick
          getRowId={(row) => row.id}
          paginationMode="server"
          page={page - 1}
          pageSize={pageSize}
          rowCount={totalCount}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={(p) => setPage(p + 1)}
          onPageSizeChange={(s) => { setPageSize(s); setPage(1); }}
        />
      </Box>
      <Snackbar
        open={openToast}
        autoHideDuration={4000}
        onClose={() => setOpenToast(false)}
        message={toastMessage}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      />
    </Box>
  );
};

export default AssignedTrips;
